var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C9.28235 12 12 9.27647 12 6C12 2.71765 9.27647 0 5.99412 0C2.71765 0 0 2.71765 0 6C0 9.27647 2.72353 12 6 12ZM3.92353 8.56471C3.65882 8.56471 3.44118 8.34118 3.44118 8.07059C3.44118 7.94118 3.49412 7.82353 3.58235 7.72941L5.30588 6.00588L3.58235 4.28235C3.49412 4.18824 3.44118 4.07059 3.44118 3.94118C3.44118 3.67059 3.65882 3.45882 3.92353 3.45882C4.06471 3.45882 4.17647 3.50588 4.26471 3.6L5.99412 5.32353L7.74118 3.59412C7.84118 3.49412 7.94706 3.44706 8.07647 3.44706C8.34118 3.44706 8.55882 3.66471 8.55882 3.92941C8.55882 4.06471 8.51765 4.17059 8.41765 4.27647L6.68824 6.00588L8.41177 7.72353C8.50588 7.82353 8.55294 7.93529 8.55294 8.07059C8.55294 8.34118 8.33529 8.56471 8.06471 8.56471C7.92941 8.56471 7.81177 8.50588 7.71765 8.41765L5.99412 6.69412L4.28235 8.41765C4.18824 8.51177 4.06471 8.56471 3.92353 8.56471Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.4df22d6bba826dee265efd71d0c71754.svg";
export { ForwardRef as ReactComponent };